/* Resources */
import { agenciesOrder } from "../../../helper/orders";
/* Contexts */
/* Components */
import Dashboard from "../../../components/common/dashboard/Dashboard";
import Header from "../../../components/common/Header";
import Icon from "../../../components/common/Icon";
import SearchBox from "../../../components/common/SearchBox";
import {getAdminAgencyList} from "../../../api/admin/agencyReq";
import {useEffect, useState} from "react";
import useData from "../../../hooks/useData";
import useAuth from "../../../hooks/useAuth";
import usePager from "../../../hooks/usePager";


export default function Agencies() {

    const {auth} = useAuth();
    const token = auth.token;
    const {agencyList, setAgencyList} = useData();
    const { currentPage, itemsPerPage, setTotalPages, setCurrentPage } = usePager();
    const [ filterParams, setFilterParams ] = useState({});
    const [ totalItems, setTotalItems ] = useState();

    const agenciesApi = async () => {

        const keywords = Object.keys(filterParams).length === 0 ? 'all' : JSON.stringify(filterParams);

        const response = await getAdminAgencyList(token, currentPage, itemsPerPage, keywords);

        if (!response?.error) {
            setAgencyList(response?.agencyList);
            setTotalItems(response?.totalItems)
        } else {
            setAgencyList([])
        }
    }

    useEffect(() => {
        agenciesApi()
    }, [ filterParams, currentPage, itemsPerPage ]);

    useEffect(() => {
        if (agencyList && agencyList.length < 1) {
            setCurrentPage(1)
        }
    }, [ agencyList ]);

    useEffect(() => {
        setCurrentPage(1)
        setTotalPages(Math.ceil(totalItems / itemsPerPage))
    }, [ filterParams, totalItems, itemsPerPage ]);

    const sources = "fa fa-house"

    const headers = [
        {label: "Code habilitation", key: "authorizationCode"},
        {label: "Nom", key: "name"},
        {label: "Ville", key: "city"},
        {label: "CP", key: "zipcode"},
        {label: "Siret", key: "siret"},
        {label: "Date création", key: "registrationDate"},
        {label: "Agence visible", key: "enabled"}
    ];

    return (
        <main className="admin">
            <Header parent="Administration"
                    location="Agences"
                    slug="/admin/accueil"
            />
            <div className="content-container">
                <Icon source={sources} color="blue" span="Liste des agences"/>
                <SearchBox location="Agences" headers={headers} filename="Agences" setFilterParams={setFilterParams} />
                <div className="dashboard">
                    <Dashboard totalItems={totalItems} location="Agences" agenciesApi={agenciesApi} dataObject={agencyList || []} order={agenciesOrder}/>
                </div>
            </div>
        </main>
    )
}